module.exports = __webpack_public_path__ + "img/CDP.f533411d.png";